import { z } from 'zod'

export const userLanguageCodeSchema = z.enum(['system', 'ko', 'en', 'ja'])
export type UserLanguageCode = z.infer<typeof userLanguageCodeSchema>

export const updateUserLocaleRequestSchema = z
  .object({
    timezoneCode: z.string().trim().min(1).optional(),
    languageCode: userLanguageCodeSchema.optional(),
  })
  .refine(({ timezoneCode, languageCode }) => timezoneCode !== undefined || languageCode !== undefined, {
    message: 'USER_LOCALE_FIELD_REQUIRED',
  })

export const updateUserLocaleResponseSchema = z.object({
  timezoneCode: z.string().trim().min(1),
  languageCode: userLanguageCodeSchema,
})

export type UpdateUserLocaleRequest = z.infer<typeof updateUserLocaleRequestSchema>
export type UpdateUserLocaleResponse = z.infer<typeof updateUserLocaleResponseSchema>

export const normalizeUserLanguageCode = (languageCode: string | null | undefined): UserLanguageCode => {
  const normalizedLanguageCode = languageCode?.trim().toLowerCase()

  switch (normalizedLanguageCode) {
    case 'ko':
    case 'kr':
      return 'ko'
    case 'en':
      return 'en'
    case 'ja':
    case 'jp':
    case 'ja-jp':
      return 'ja'
    case 'system':
    default:
      return 'system'
  }
}

export const resolveDisplayLanguageCode = (
  languageCode: string | null | undefined,
  browserLanguage: string | null | undefined,
): Exclude<UserLanguageCode, 'system'> => {
  const userLanguageCode = normalizeUserLanguageCode(languageCode)

  if (userLanguageCode !== 'system') {
    return userLanguageCode
  }

  const normalizedBrowserLanguage = browserLanguage?.toLowerCase() ?? ''

  if (normalizedBrowserLanguage.startsWith('ja')) {
    return 'ja'
  }

  if (normalizedBrowserLanguage.startsWith('en')) {
    return 'en'
  }

  return 'ko'
}
